import ChartGroupingLevelSelectorFillingStrategy from './ChartGroupingLevelSelectorFillingStrategy'

function AllItemsGroupingLevelSelectorFillingStrategy() {}

AllItemsGroupingLevelSelectorFillingStrategy.prototype = new ChartGroupingLevelSelectorFillingStrategy();

AllItemsGroupingLevelSelectorFillingStrategy.prototype.fillGroupingLevelListSelector = function( listSelector )
{
    this.addUsersItem( listSelector );
    this.addUserGroupsItemIfNeeded( listSelector );
    this.addTimeZoneGroupsItemIfNeeded( listSelector );

    listSelector.addSeparator();

    this.addCustomersItem( listSelector );
    this.addProjectsItem( listSelector );
    this.addTypesOfWorkItemIfNeeded( listSelector );
    listSelector.addSeparator();
    this.addDaysItem( listSelector );
    this.addWeeksItem( listSelector );
    this.addMonthsItem( listSelector );
};

export default AllItemsGroupingLevelSelectorFillingStrategy


// WEBPACK FOOTER //
// ./web/js/reports/charts/AllItemsGroupingLevelSelectorFillingStrategy.js